(function (window, document, $, undefined) {
  //MENU
  $(".menuNavThirdLevelCurrent")
    .parent()
    .parent()
    .addClass("menuNavSubLevelCurrent");
  $(".menuNavSubLevelCurrent")
    .parent()
    .parent()
    .addClass("menuNavTopLevelCurrent");
  //INITIALIZE
  $("#redback").fadeTo(0, 0.5);
  $(".gallery-slide-image a, .gallery-slide-title a").click(function (event) {
    event.preventDefault();
  });
  //FADE EFFECTS
  $("#redback").mouseenter(function () {
    $(this).stop().fadeTo(200, 1);
  });
  $("#redback").mouseleave(function () {
    $(this).stop().fadeTo(200, 0.5);
  });

  $("#banner .gallery-slide-image").fadeIn(600);
  $("#banner .gallery-slide-title").fadeIn(600);
  $("#banner .gallery-slide-caption").fadeIn(600);

  $(".jsToggle").click(function (e) {
    $(".jsContent").toggleClass("banner-active");
  });
  var $windoWidth = $(window).width();

  if ($windoWidth <= 1024) {
    var menu = $("#menuNavRoot");
    if (menu.length) {
      menu.slicknav({
        prependTo: "#menuNavDiv",
        closedSymbol: "+",
        openedSymbol: "-",
        showChildren: false,
        allowParentLinks: true,
        label: "",
      });
    }
  }

  $(window).resize(function () {
    var $windoWidth = $(window).width();

    if ($windoWidth <= 1024) {
      var menu = $("#menuNavRoot");
      if (menu.length) {
        menu.slicknav({
          prependTo: "#menuNavDiv",
          closedSymbol: "+",
          openedSymbol: "-",
          showChildren: false,
          allowParentLinks: true,
          label: "",
        });
      }
    }
  });
})(window, document, jQuery);
